import Accept from 'components/Button/Accept';
import Reject from 'components/Button/Reject';
import { useFlow } from 'contexts/FlowContext';
import { useOneClick } from 'contexts/OneClickBuyContext';
import { getPaymentMethodOptions } from 'helpers/offerPaymentMethods';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonsContainer, OtherMethodLink } from './Container';

const UpsellButtons: React.FC = () => {
	const {
		isSending,
		isCalculating,
		decline,
		pay,
		allowedPaymentMethods,
		highlightedPaymentMethod,
		selectedPaymentMethod,
		isChoosingPaymentMethod,
		setIsChoosingPaymentMethod,
		isNewCardRequired,
	} = useOneClick();
	const { flow, handleRejectFlow } = useFlow();
	const { t } = useTranslation('upsell');

	const acceptText = isNewCardRequired
		? t('actions.continueToCheckout')
		: isChoosingPaymentMethod
			? t('actions.confirm')
			: t('actions.buyWith', { method: t(`paymentMethods.${highlightedPaymentMethod}`) });
	const hasOtherMethods = getPaymentMethodOptions(allowedPaymentMethods, highlightedPaymentMethod).length > 1;

	return (
		<ButtonsContainer>
			<Accept
				isCalculating={isCalculating || !selectedPaymentMethod}
				isSending={isSending}
				onClick={pay}
				text={String(acceptText)}
			/>
			{!isChoosingPaymentMethod && hasOtherMethods && (
				<OtherMethodLink type='button' onClick={() => setIsChoosingPaymentMethod(true)}>
					{String(t('actions.otherMethod'))}
				</OtherMethodLink>
			)}
			<Reject
				onClick={() => {
					flow ? handleRejectFlow() : decline();
				}}
				isCalculating={isCalculating}
				isSending={isSending}
			/>
		</ButtonsContainer>
	);
};

export default UpsellButtons;
